import { createContext, useContext } from "react";

export const AdminEventsContext = createContext(null);

export function useAdminEvents() {
  const ctx = useContext(AdminEventsContext);
  if (!ctx) {
    throw new Error("useAdminEvents must be used within AdminLayout");
  }
  return ctx;
}
